import { Injectable } from '@angular/core';
import { BaseRepository } from './base.repository';
import { catchError, map, Observable, throwError } from 'rxjs';
import {
 GetUserProfileResponse,
 LatestActiveReserveResponse,
} from '@core/models/DTOs/userProfile.dto';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
 providedIn: 'root',
})
export class UserProfileRepository extends BaseRepository {
 getUserProfile(): Observable<GetUserProfileResponse> {
  let url = this.baseUrl + 'UserProfile/GetUserProfile';
  return this.getWithoutCache(url);
 }
 getLatestActiveReserve(): Observable<LatestActiveReserveResponse> {
  let url = this.baseUrl + 'v1/account/latestActiveReserve';
  return this.getWithoutCache(url);
 }
 GetConfigData(): Observable<string> {
  let url = this.baseUrl + 'common/GetConfigData';
  return this.get(url);
 }
 refreshToken(refreshToken: string) {
  let url = this.baseUrl + 'UserProfile/refreshToken';
  return this.http.post(url, { refreshToken }).pipe(
   map((response: any) => {
    // Store the new access token
    localStorage.setItem('AccessToken', response.accessToken);
    return response.accessToken;
   }),
   catchError((error: HttpErrorResponse) => {
    // Handle the error appropriately here (e.g., redirect to login)
    return throwError(error);
   })
  );
 }
}
